// strings/hud.ts (M0-T06, §7.1) — HUD buttons and A-button verbs (`a` = the idle A-button label, rev 7). The rotate card's words moved
// to strings/fullscreen.ts (2026-10-18).
import type { StringBank } from '../schema/strings';

export default {
  a: 'A', menu: 'Menu', pockets: 'Pockets', mail: 'Mail', chat: 'Chat', emotes: 'Emotes', tool: 'Tool', run: 'Run', cancel: 'Cancel',
  verbShake: 'Shake', verbPickUp: 'Pick up', verbEnter: 'Enter', verbExit: 'Exit', verbReel: 'Reel', verbTalk: 'Talk', verbNext: 'Next', verbDig: 'Dig',
  verbCast: 'Cast', verbRead: 'Read', verbPlant: 'Plant', verbRemove: 'Remove', reconnecting: 'Reconnecting…',
  updateRequired: 'A new version of {app} is ready.', reload: 'Reload',
  replaced: 'You opened {app} somewhere else.', removedFromTown: 'You no longer live in {town}.', leaveTown: 'Leave town', signOut: 'Sign out', here: '{n} here',
  perfOverlay: 'Performance overlay',
} as const satisfies StringBank;
